let reseller = (function () {
  const EXPIRE_TIME_WKN = 7 * 24 * 60 * 60; // 1 week
  const RECOMMENDATION_RESELLER_ID = '841';
  const ALLOWED_RESELLERS = ["1800", "1809", "1812"];

  function fillInputs(identifier, value) {
    const hiddenInput = document.querySelector(
      "[data-fill-from-storage='" + identifier + "']",
    );
    if (hiddenInput) {
      hiddenInput.value = value;
    }
  }

  function extractCid(cid) {
    let cidRegex = new RegExp('^ch:AFFILIATE.*pl:([^|]+?)([_&].*|$)');
    let matches = cid.match(cidRegex);
    return matches && matches[1] ? matches[1] : false;
  }

  function getFromUrl(urlParamName) {
    let url = new URL(window.location.href);
    let urlParamValue = url.searchParams.get(urlParamName);
    return urlParamValue ? urlParamValue : null;
  }

  function getFromLocalStorage(itemName) {
    let itemValue = localStorage.getItem(itemName);
    return itemValue ? atob(itemValue) : null;
  }

  function deleteFromLocalStorage(name) {
    localStorage.removeItem(name);
    localStorage.removeItem(name + '_expire_time');
  }

  function deleteExpired(name) {
    let itemValue = atob(localStorage.getItem(name));
    let itemExpireTime = atob(localStorage.getItem(name + '_expire_time'));
    if (!itemValue || !itemExpireTime) {
      return;
    }
    let timeNow = Date.now();
    if (itemExpireTime < timeNow) {
      deleteFromLocalStorage(name);
    }
  }

  function setLocalStorage(name, value, expireTime) {
    let timeNow = Date.now();
    localStorage.setItem(name, btoa(value));
    localStorage.setItem(name + '_expire_time', btoa(timeNow + expireTime));
  }

  function handleRecommendation() {
    // reseller of the current page, provided by the EDDL page_view payload (tracking/data_layer.html.twig)
    const pageResellerId = window.eddlPageView?.page?.reseller_id;
    if (
      typeof window.eddlPageView !== 'undefined' &&
      pageResellerId !== RECOMMENDATION_RESELLER_ID &&
      !ALLOWED_RESELLERS.includes(pageResellerId)
    ) {
      deleteFromLocalStorage('wkn');
      return;
    }
    let recommendation = getFromUrl('empfehlung') + '';
    let recommender = getFromUrl('empfaenger') + '';
    let wkn = null;

    if (recommendation && recommendation.length === 13) {
      wkn = recommendation;
      if (recommender && recommender.length === 9) {
        wkn += '|' + recommender.substring(0, 6);
      }
      setLocalStorage('wkn', wkn);
    }

    wkn = getFromLocalStorage('wkn');
    if (wkn) {
      fillInputs('wkn', wkn);
    }
  }
  function handleCID() {
    deleteExpired('wkn');

    let cid = getFromUrl('cid');
    let wkn = null;

    if (cid) {
      wkn = extractCid(cid);
      const resellerId = getFromUrl('reseller');
      if (wkn && ALLOWED_RESELLERS.includes(resellerId)) {
        setLocalStorage('wkn', wkn, EXPIRE_TIME_WKN);
      } else {
        deleteFromLocalStorage('wkn');
        return;
      }
    }

    wkn = getFromLocalStorage('wkn');
    if (wkn) {
      fillInputs('wkn', wkn);
    }
  }

  function init() {
    handleCID();
    handleRecommendation();
  }

  return {
    init: init,
  };
})();
reseller.init();
